import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65eaa3b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login_bg" }
const _hoisted_2 = { class: "login-wrap" }
const _hoisted_3 = { class: "login-left" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "login_right" }
const _hoisted_6 = { class: "box-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "文品易通")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "ft-18" }, "微信扫码 安全登录", -1))
const _hoisted_9 = { class: "qrCode" }
const _hoisted_10 = { class: "agreement" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ft-14" }, [
  /*#__PURE__*/_createTextVNode(" 登录视为您已同意"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://wpyt.microcomputation.com/api/upload/%E6%96%87%E5%93%81%E6%98%93%E9%80%9A%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.html"
  }, "用户协议"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ©2023文品易通 FROM 微科智检 ")
], -1))

import { ref, reactive, unref, onMounted, onUnmounted, h } from "vue";
import { getLoginQrCode, getOpenId } from "@/service/login/request.js";
import { ElMessage, ElNotification } from "element-plus";
import axios from "@/utils/axios.js";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import type { FormInstance, FormRules, TabsPaneContext } from "element-plus";
import { clearTimer } from "@/service/common.js";
import md5 from "js-md5";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPc',
  setup(__props) {

const router = useRouter();
const store = useStore();
const activeName = ref("first");
const timer = ref(null);
const ruleFormRef = ref();
const agreementChecked = ref(false);

// 轮播图
const imgList = ref([
  {
    id: 1,
    url: require("@/assets/img/banner1.png"),
  },
  {
    id: 2,
    url: require("@/assets/img/banner2.png"),
  },
  {
    id: 3,
    url: require("@/assets/img/banner3.png"),
  },
  {
    id: 4,
    url: require("@/assets/img/banner4.png"),
  },
]);

// 账号登录表单
const loginForm = reactive({
  phone: "",
  password: "",
});

// 微信二维码
const qrData = reactive({
  qrCode: "",
  id: "",
});

// 定义校验规则
const rules = reactive<FormRules>({
  phone: [{ required: true, message: "账号不能为空", trigger: "blur" }],
  password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
});

function showCustomNotification() {
  ElNotification({
    title: "定制化服务通知",
    message: h("p", null, [
      h(
        "span",
        null,
        "如果您希望获得更定制化的功能与更优质的体验，我们可以为您提供私有化开发与部署服务，欢迎致电"
      ),
      h("span", { style: "color: #0054fe" }, "13316328117"),
      h("span", null, "或联系"),
      h("span", { style: "color: #0054fe" }, "sales@microcomputation.com"),
      h("span", null, "了解详情。"),
    ]),
    type: "warning",
    position: "bottom-right",
    duration: 0,
    style: { width: "460px" },
  });
}

// 切换登录方式
const handClick = (tab: TabsPaneContext, event: Event) => {
  if (tab.index == "1") {
    clearTimer(timer.value);
  } else {
    get_loginQrCode();
  }
};

// 获取公众号二维码
const get_loginQrCode = async () => {
  const res = await getLoginQrCode();
  if (res && res.code && res.code == 200) {
    qrData.qrCode = res.data.QrCode;
    qrData.id = res.data.id;
    timer.value = setInterval(() => {
      setTimeout(() => {
        get_openId();
      }, 0);
    }, 3000);
  }
};

// 获取openId检测是否扫码关注
const get_openId = () => {
  let params = new FormData();
  params.append("eventKey", qrData.id);
  axios.post("/wx/getOpenId", params).then((resp) => {
    if (resp && resp.code && resp.code == 200) {
      router.push("/index");
      sessionStorage.setItem("openId", resp.data.openId);
      store.commit("changeLogin", resp.authorization);
      clearInterval(timer.value);
      timer.value = null;
      showCustomNotification();
    }
  });
};

// 账号密码登录
const submitForm = async () => {
  const form = unref(ruleFormRef);
  if (!form) return;
  await form.validate((valid, fields) => {
    if (valid) {
      if (agreementChecked.value) {
        let loginDto = {
          userName: loginForm.phone,
          password: md5(loginForm.password),
          isEncrypt: 1,
        };
        axios
          .post("/login", JSON.stringify(loginDto))
          .then((resp) => {
            if (resp && resp.code && resp.code == 200) {
              router.push("/index");
              sessionStorage.setItem("openId", resp.data.openId);
              store.commit("changeLogin", resp.authorization);
              showCustomNotification();
            } else {
              ElMessage.error(resp.msg);
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      } else {
        ElNotification({
          title: "提示",
          message: "请阅读并同意用户协议",
          type: "warning",
        });
      }
    }
  });
};

// 点击回车键登录
const keyDown = (e) => {
  if (e.keyCode == 13) submitForm();
};

// 点击跳转报告查验页面
const handReportCheck = () => {
  const { href } = router.resolve("/report_verify");
  window.open(href, "_blank");
};

onMounted(() => {
  window.addEventListener("keydown", keyDown);
  get_loginQrCode();
});

onUnmounted(() => {
  clearTimer(timer.value);
  window.removeEventListener("keydown", keyDown, false);
});

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_doc_searchIcon = _resolveComponent("doc-searchIcon")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_User = _resolveComponent("User")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_card, { "body-style": { borderRadius: '25px' } }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { class: "login" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_el_carousel, { arrow: "never" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_carousel_item, {
                        key: item.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: item.url
                          }, null, 8, _hoisted_4)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "report-check",
                  onClick: handReportCheck
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_tooltip, {
                      content: "报告查验",
                      placement: "left",
                      "popper-class": "tooltip-theme"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, {
                          color: "#0054fe",
                          size: "45px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_doc_searchIcon)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _hoisted_7,
                _createVNode(_component_el_tabs, {
                  class: "demo-tabs",
                  modelValue: activeName.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeName).value = $event)),
                  onTabClick: handClick
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tab_pane, {
                      label: "快捷登录",
                      name: "first"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_el_image, {
                            src: qrData.qrCode,
                            fit: "cover"
                          }, null, 8, ["src"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_tab_pane, {
                      label: "账号登录",
                      name: "second"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form, {
                          class: "form login-form",
                          "label-width": "70px",
                          "label-position": "left",
                          model: loginForm,
                          rules: rules,
                          ref_key: "ruleFormRef",
                          ref: ruleFormRef
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "",
                              prop: "phone"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  size: "large",
                                  modelValue: loginForm.phone,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginForm.phone) = $event)),
                                  modelModifiers: { trim: true },
                                  type: "text",
                                  placeholder: "请输入账号"
                                }, {
                                  prefix: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_User)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              label: "",
                              prop: "password"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  size: "large",
                                  modelValue: loginForm.password,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginForm.password) = $event)),
                                  modelModifiers: { trim: true },
                                  type: "password",
                                  placeholder: "请输入密码",
                                  "show-password": ""
                                }, {
                                  prefix: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Lock)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_row, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createVNode(_component_el_checkbox, {
                                        modelValue: agreementChecked.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((agreementChecked).value = $event)),
                                        label: "",
                                        size: "large"
                                      }, null, 8, ["modelValue"]),
                                      _createTextVNode(" 我已阅读并同意 "),
                                      _createVNode(_component_el_link, {
                                        underline: false,
                                        target: "_blank",
                                        href: "https://wpyt.microcomputation.com/api/upload/%E6%96%87%E5%93%81%E6%98%93%E9%80%9A%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.html"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("用户协议")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createVNode(_component_el_button, {
                                      size: "large",
                                      color: "#0054fe",
                                      class: "form-btn",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm())),
                                      onKeydown: _withKeys(keyDown, ["enter"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" 登 录 ")
                                      ]),
                                      _: 1
                                    }, 8, ["onKeydown"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model", "rules"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _hoisted_11
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})